export const {
  REACT_APP_API_URL: API_URL,
  REACT_APP_ZOHO_SALESIQ_WIDGET_CODE: ZOHO_SALESIQ_WIDGET_CODE,
  REACT_APP_ZOHO_SALESIQ_WIDGET_URL: ZOHO_SALESIQ_WIDGET_URL,
} = process.env;
export const TOKEN = "TOKEN";
export const API = API_URL;
